import * as React from 'react';
import { AppBar, Box, IconButton, Toolbar, Typography, useTheme } from '@mui/material';
import { Menu, Search } from '@mui/icons-material';

import { AppLogo } from 'components';
import { SearchResultDialog } from 'dialogs/search';
import { selectLayoutSlice, updateLayout } from 'store/slices/layout.slice';
import { useAppDispatch, useAppSelector } from 'store/store.hook';

interface AuthHeaderMobileLayoutProps {}

export const AuthHeaderMobileLayout: React.FC<AuthHeaderMobileLayoutProps> = () => {
  const dispatch = useAppDispatch();
  const { headerTitle = 'CleanCode' } = useAppSelector(selectLayoutSlice);
  const theme = useTheme();
  const [visibleSearchResultDialog, setVisibleSearchResultDialog] = React.useState<boolean>(false);

  return (
    <>
      <AppBar sx={{ position: 'fixed', backgroundColor: 'white' }}>
        <Toolbar>
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              paddingX: 8,
            }}
          >
            <Typography noWrap sx={{ textAlign: 'center', width: '100%', color: theme.palette.text.primary }}>
              {headerTitle}
            </Typography>
          </Box>

          <AppLogo mini />

          <IconButton
            color="primary"
            onClick={() => {
              setVisibleSearchResultDialog(true);
            }}
            sx={{ marginLeft: 'auto' }}
          >
            <Search />
          </IconButton>

          <IconButton
            color="primary"
            onClick={() => {
              dispatch(updateLayout({ authSidebarMenuOpened: true }));
              document.body.style.overflow = 'hidden';
            }}
          >
            <Menu />
          </IconButton>
        </Toolbar>
      </AppBar>

      <SearchResultDialog visible={visibleSearchResultDialog} setVisible={setVisibleSearchResultDialog} />
    </>
  );
};
